export const getCatalogAndTemplate = (catalogAndTemplate, storedCatalog, storedTemplates) => {
    const catalog = catalogAndTemplate
        ? catalogAndTemplate.catalog
        : storedCatalog;
    const templates = catalogAndTemplate
        ? catalogAndTemplate.templates
        : storedTemplates;
    return { catalog, templates };
};
